// extracted by mini-css-extract-plugin
export default {"details":"CategoryDetails-module__details__H9+yy","category":"CategoryDetails-module__category__+zN0Y","content":"CategoryDetails-module__content__W+ts+"};